export enum ApproveDialogResults {
  Cancel = 0,
  ApproveAndViewPayforms = 1,
  ApproveAndNextPayform = 2,
}
